import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('visible'), delay);
          obs.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);
  return ref;
}

const testimonials = [
  {
    quote: "Kendrick's inspection background was a game-changer. He caught things during showings that saved us thousands. I felt confident every step of the way.",
    name: "Sarah M.",
    context: "First-Time Buyer · Monroe County",
  },
  {
    quote: "He made selling my parents' estate so much easier. Honest, patient, and he truly cared about getting it right for our family.",
    name: "Tom R.",
    context: "Estate Sale",
  },
  {
    quote: "We were buying and selling at the same time, and Kendrick coordinated everything perfectly. No stress, no gaps — just results.",
    name: "Jennifer & Mike L.",
    context: "Move-Up Buyers",
  },
];

export default function HomeTestimonials() {
  const headingRef = useReveal(0);
  const card0 = useReveal(0);
  const card1 = useReveal(150);
  const card2 = useReveal(300);
  const cardRefs = [card0, card1, card2];
  const ctaRef = useReveal(0);

  return (
    <section className="py-14 sm:py-20 bg-[#0F1F3A]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        {/* Heading */}
        <div ref={headingRef} className="reveal text-center mb-10 sm:mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C8923A] mb-4 font-medium">What Clients Say</p>
          <h2 className="font-cormorant text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight">
            Real People. <em className="not-italic font-semibold">Real Results.</em>
          </h2>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 mb-10 sm:mb-12">
          {testimonials.map((t, i) => (
            <div
              key={i}
              ref={cardRefs[i]}
              className="reveal scale bg-white/8 border border-white/10 rounded-lg p-8 hover-lift"
              style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}
            >
              <i className="ri-double-quotes-l text-3xl text-[#C8923A]/40 mb-5 block"></i>
              <p className="text-white/80 text-sm leading-relaxed mb-8 italic">"{t.quote}"</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white font-semibold text-sm">{t.name}</p>
                <p className="text-white/50 text-xs mt-0.5">{t.context}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div ref={ctaRef} className="reveal text-center">
          <Link
            to="/testimonials"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white/70 hover:text-white border-b border-white/30 hover:border-white pb-0.5 transition-all whitespace-nowrap"
          >
            Read All Reviews
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
